<mat-toolbar class="footer">
    <mat-toolbar-row>
        <span>v{{ version }}</span>
        <span class="flex-spacer"></span>
        <span>Built and Managed by Surveyor Pro Limited {{ currentYear }} &copy;.</span>
    </mat-toolbar-row>
</mat-toolbar>
